export default __webpack_public_path__ + "static/media/bloodywall.272e28d2.png";